<div class="chart-container {{ barChartConfig }}">
  <div class="bar-chart"
       #chart></div>
</div>
